import React from 'react';

export const BrandLogo = () => (
    <span className='hs-brand-logo'>
        <svg width="30" height="33" viewBox="0 0 40 44" fill="none">
            <path d="M20 1.5 38 11.75v20.5L20 42.5 2 32.25v-20.5Z" fill="#0073F0" />
            <rect x="10" y="20" width="5.5" height="14" rx="1" fill="#fff" />
            <rect x="17.25" y="12" width="5.5" height="22" rx="1" fill="#fff" />
            <rect x="24.5" y="16.5" width="5.5" height="17.5" rx="1" fill="#fff" />
        </svg>
        <span className='hs-brand-name'>Halo<span>Stan</span></span>
    </span>
);
